import React from 'react'
import { SideWrapper, Container } from './style'
import { BackgroundQuote, Dashboardlogo, Dashboardimage } from 'src/assets'
const SideInfo = ({ children }: any) => {
  return (
    <SideWrapper>
      <Container>
        <div>
          {' '}
          <img src={Dashboardlogo} alt="" />
        </div>
        <div className="info">
          <div>
            <h2>{children}</h2>
            <div>
              <p className="create">
                Let’s talk about what financial success looks like and how F&K
                Savings can help you get there.
              </p>
            </div>
          </div>
          {/* <div>
            <img src={BackgroundQuote} alt="" />
          </div>
          <div>
            <h2>
              Create an account Let’s talk about what financial success looks
              like and how F&K Savings can help you get there.
            </h2>
          </div>
          <div className="speaker-note">
            <img src={Dashboardimage} alt="" />
            <div className="speaker">
              <h3>Tony Samuel</h3>
              <p>Digital Marketer</p>
            </div>
          </div> */}
        </div>
      </Container>
    </SideWrapper>
  )
}

export { SideInfo }
